// promotionState.js
import { ref } from 'vue';

// Create a reactive object for tracking updates
export const promotionUpdateStatus = ref(null);
